'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundImage = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bgImage = (0, _styledSystem.style)({
  prop: 'image',
  alias: 'src',
  cssProperty: 'backgroundImage',
  getter: function getter(n) {
    return 'url(' + n + ')';
  }
});

var BackgroundImage = exports.BackgroundImage = (0, _systemComponents2.default)({
  width: 1,
  ratio: 3 / 4,
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}, bgImage, 'ratio', 'backgroundSize', 'backgroundPosition', 'space', 'color');

BackgroundImage.displayName = 'BackgroundImage';

exports.default = BackgroundImage;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/BackgroundImage.js
// module id = 209
// module chunks = 35783957827783 162898551421021